export enum DropboxFolderType {
    Repairs = 'repairs',
    Manuals = 'manuals',
    Firmwares = 'firmwares',
}

export type DropboxToken = {
    id: number;
    email: string;
    sync_type: DropboxFolderType;
    is_active: boolean;
    refresh_token_expiration_date: string;
    is_expired: string;
};
